/**
 * Équivalent de la classe Triple de Kotlin
 */
export class Triple<T, U, V> {
    constructor(
        public first: T,
        public second: U,
        public third: V,
    ) {}
}
